import script from "./PatientCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientCard.vue?vue&type=script&setup=true&lang=js"

import "./PatientCard.vue?vue&type=style&index=0&id=f81b26ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f81b26ae"]])

export default __exports__